import { NumberComparisonOperator } from "@redotech/redo-flows-core-common/comparison-operators";
import { numberComparisonToLabel } from "@redotech/redo-flows-core-schema-common/expressions/number-expression";
import { T, useTranslation } from "@redotech/redo-i18n";
import { Text } from "@redotech/redo-web/text";
import { isDef } from "@redotech/util/checks";
import { memo } from "react";

export const WeightComparisonDetails = memo(function WeightComparisonDetails({
  field,
  matchType,
  matchValue,
}: {
  field: string;
  matchType?: NumberComparisonOperator;
  matchValue?: number;
}) {
  const { t } = useTranslation();
  const lbs = isDef(matchValue) ? Math.floor(matchValue / 16) : undefined;
  const oz = isDef(matchValue) ? matchValue % 16 : undefined;
  const operatorLabel = matchType ? numberComparisonToLabel[matchType] : "";

  const poundLabel =
    isDef(lbs) && lbs ? t("{{count}} lbs", { count: lbs }) : undefined;
  const ounceLabel =
    isDef(oz) && oz ? t("{{ounces}} oz", { ounces: oz }) : undefined;
  const weightLabel = [poundLabel, ounceLabel].filter(Boolean).join(" ");

  return (
    <T>
      If <Text fontWeight="semibold">{field}</Text> is{" "}
      <Text>{operatorLabel}</Text>{" "}
      <Text fontWeight="semibold">{weightLabel}</Text>
    </T>
  );
});
